import { Dialog, dialogClasses } from '@mui/material';
import styled from 'styled-components';

export const StyledDialog = styled(Dialog)`
  & .${dialogClasses.paper} {
    min-width: fit-content;
    max-width: 100%x;
    min-height: fit-content;
    max-height: 100%;
  }
`;

export const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  max-width: 750px;
  box-sizing: border-box;
  padding: 35px 50px 35px 50px;
  z-index: 1;
`;

export const ModalText = styled.span`
  align-self: center;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 30px;
  color: #000000;
  word-break: keep-all;
`;

export const ModalStrongText = styled(ModalText)`
  font-weight: 700;
  white-space: nowrap;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 20px 50px 20px;
  width: 100%;
  box-sizing: border-box;
  padding: 15px;
  border: 1px solid var(--Hscan_light_grey, #e7e7e7);
  border-radius: 10px;
  word-break: keep-all;
  background-color: white;
`;

export const InnerFrame = styled.div<{ mobile?: boolean }>`
  margin-left: ${props => (props.mobile ? '0' : '30px')};
`;

export const CardHeading = styled.h3`
  margin: 0;
  align-self: flex-start;
  font-size: 14px;
  line-height: 2;
  font-weight: 700;
  color: var(--HScan_blue_grey, #686b7b);
  white-space: normal;
  word-break: keep-all;
  text-align: center;
`;

export const TextContainer = styled.div`
  display: flex;
`;

export const CardText = styled.div`
  font-size: 14px;
  font-weight: 500;
  padding-top: 13px;
  padding-bottom: 5px;
  color: var(--HScan_blue_grey, #686b7b);
`;

export const SaveButton = styled.div<{ selected?: boolean }>`
  width: min-content;
  min-width: 50px;
  padding: 7px;
  margin-top: 10px;
  border-radius: 7px;
  background-color: ${props =>
    props.selected ? 'var(--HScan_Light_Blue, #2e5be0)' : '#e8e8e8'};
  &:hover {
    ${props => (props.selected ? 'cursor: pointer;' : '')};
  }
`;

export const ButtonText = styled.div<{ selected?: boolean }>`
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  color: ${props => (props.selected ? 'white' : '#bcbcbc')};
`;

export const CheckboxContainer = styled.div<{ mobile?: boolean }>`
  display: ${props => (props.mobile ? 'block' : 'flex')};
  //align-items: center;
`;

export const CheckboxInnerContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const LabelContainer = styled.div<{ mobile?: boolean }>`
  display: flex;
  flex-direction: ${props => (props.mobile ? 'column' : '')};
`;

export const CheckboxButton = styled.input`
  margin-right: 15px;
  margin-left: 0;
  width: 18px;
  height: 18px;
  &:checked {
    border-color: #2e5be0;
    border-width: 10px;
  }
`;

export const Label = styled.label`
  margin-right: 20px;
  font-size: 14px;
  line-height: 2.5;
  font-weight: 500;
  color: #686b7b;
`;
